import { Component, Input, OnInit, OnChanges, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RefundRequestPreviewComponent } from './refund-request-preview/refund-request-preview.component';
import { RefundCommentSectionComponent } from './refund-comment-section/refund-comment-section.component';
import { RefundRequestActivityLogComponent } from './refund-request-activity-log/refund-request-activity-log.component';

@Component({
  selector: 'app-refund-request-list',
  templateUrl: './refund-request-list.component.html',
  styleUrls: ['./refund-request-list.component.scss'],
})
export class RefundRequestListComponent implements OnInit, OnChanges {
  public login_user_details: any = {};
  public UserID: any;
  public updatetable: boolean = false;
  constructor(
    public router: Router,
    public cookieService: CookieService,
    public activatedRoute: ActivatedRoute,
    private apiservice: ApiservicesService,
    public dialog: MatDialog,
    public matSnackBar: MatSnackBar
  ) {
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};
    console.log('details======>', this.login_user_details);
    this.UserID = this.login_user_details?.userinfo?._id;
    console.log(this.UserID);
  }

  @Input() userId!: string;
  @Input() heading: string = 'Refund Request List';
  @Input() tabledatatalist: any[] = [];
  loading = false;
  public loader = false;

  date_search_source_count: any = 0;

  public listprogressBar: any = false;
  tabledata_header_skip: any = ['_id'];

  modify_header_array: any = {
    allProductNames: 'Product(s)',
    // latestComment: 'Coments',
    latestComment: 'Comments',
    refund_request_number: 'Request ID',
    orderNumber: 'Order Number',
    request_type: 'Type',
    refund_request_status: 'Status',
    createdAt: 'Date Submitted',
  };

  public base_api_url = environment.api_url;

  deleteendpoint = '';
  updateendpoint = '';
  date_search_source: any = 'refund-processing/refund-processing-list';
  date_search_endpoint: any = 'refund-processing/refund-processing-list';
  tablename = 'refund_request_list';
  editroute = '';
  tabledata_detail_skip: any = ['_id'];

  statusarray: any = [
    { val: 'Pending', name: 'Pending' },
    { val: 'Approved', name: 'Approved' },
    { val: 'Rejected', name: 'Rejected' },
  ];

  search_settings: any = {
    datesearch: [
      {
        startdatelabel: 'Request On Start Date',
        enddatelabel: 'Request On End Date',
        submit: 'Search',
        field: 'createdAt',
      },
    ],
    textsearch: [
      { label: 'Search By Request ID', field: 'refund_request_number' },
      { label: 'Search By Request Type', field: 'request_type' },
    ],
    selectsearch: [
      {
        label: 'Search By Refund Status',
        field: 'refund_request_status',
        values: [
          {
            val: 'PENDING_CUSTOMER_RESPONSE',
            name: 'Pending Customer Response',
          },
          { val: 'PENDING_ADMIN_ACTION', name: 'Pending Admin Action' },
          { val: 'SUBMITTED_TO_PRINTIFY', name: 'Submitted To Printify' },
          { val: 'REPRINT_ORDERED', name: 'Reprint Ordered' },
          { val: 'REFUND_PROCESSED', name: 'Refund Processed' },
          { val: 'DENIED', name: 'Denied' },
          { val: 'NEW_ADMIN_COMMENT', name: 'New Admin Comment' },
        ],
      },
    ],
  };

  searchendpoint = 'refund-processing/refund-processing-list';

  sortdata: any = {
    type: 'desc',
    field: 'createdAt',
    options: [
      'allProductNames',
      'latestComment',
      'refund_request_number',
      'orderNumber',
      'request_type',
      'refund_request_status',
      'createdAt',
    ],
  };

  datacollection: any = 'refund-processing/refund-processing-list';

  limitcond: any = {
    limit: 10,
    skip: 0,
    pagecount: 1,
  };

  public refundRequestList_updatetable: boolean = false;

  public customlistenbutton: any = {
    flag: true,
    tooltipflag: true,
    buttons: [],
  };

  libdata: any = {
    basecondition: {},
    updateendpoint: '',
    hidedeletebutton: true,
    hideviewbutton: true,
    hideeditbutton: true,
    hidestatustogglebutton: true,
    hidemultipleselectbutton: true,
    hideaction: false,
    updateendpointmany: '',
    deleteendpointmany: '',

    tableheaders: [
      'allProductNames',
      'latestComment',
      'orderNumber',
      'refund_request_number',
      'request_type',
      'refund_request_status',
      'createdAt',
    ],

    colpipes: [
      { type: 'datetime', col: 'createdAt', format: 'MMMM D YYYY, h:mm A' },
    ],
    custombuttons: [
      {
        label: 'Preview',
        type: 'listner',
        id: 'preview_btn',
        tooltip: 'Preview',
        name: 'preview_btn',
        classname: 'previewButton',
      },

      {
        label: 'Comment',
        type: 'listner',
        headermessage: 'Comment',
        tooltip: 'Comment',
        name: 'comment_btn',
        classname: 'refundRequestComments',
        id: 'comment_btn',
      },
      {
        label: 'Activity Logs',
        type: 'listner',
        headermessage: 'Activity Logs',
        tooltip: 'Activity Logs',
        name: 'activity_btn',
        classname: 'refundRequestActivityLog',
        id: 'activity_btn',
      },
    ],
  };
  updateTableAfterSubmit() {
    this.updatetable = !this.updatetable;
  }

  ngOnInit() {
    this.loader = true;
    if (this.userId) {
      this.libdata.basecondition.user_id =
        this.login_user_details?.userinfo?._id;
    }

    this.apiservice
      .getHttpDataPost('refund-processing/refund-processing-list', {
        condition: {
          limit: 10,
          skip: 0,
        },
        searchcondition: {
          user_id: this.UserID,
        },
        sort: {
          type: 'desc',
          field: 'createdAt',
        },
        project: {},
      })
      .subscribe((response: any) => {
        this.loader = false;
        if (response?.results) {
          this.tabledatatalist = response?.results?.res || [];
        }
      });
    //   this.activatedRoute.data.subscribe((response: any) => {
    //     if (response.response.status === 'success') {
    //       this.tabledatatalist = response?.response?.results?.res || [];
    //     }
    //   }
    // );
    this.date_search_source_count = 0; // Also reset the count
    let payload = {};
    payload = {
      condition: {
        limit: 10,
        skip: 0,
      },
      searchcondition: {
        user_id: this.UserID,
      },
      sort: {
        type: 'desc',
        field: 'createdAt',
      },
      project: {},
    };
    this.apiservice
      .getHttpDataPost(
        'refund-processing/refund-processing-list-count',
        payload
      )
      .subscribe((response: any) => {
        if (response && response.count) {
          this.date_search_source_count = response.count;
        }
      });
  }

  ngOnChanges(): void {
    // if (this.userId) this.fetchRefundRequests();
  }

  listenLiblistingChange(data: any = null) {
    const rowData = data?.custombuttonclick?.data;
    if (data?.custombuttonclick?.btninfo?.id === 'preview_btn') {
      // const dialogRef = this.dialog.open(RefundRequestPreviewComponent, {
      //           panelClass: 'custom-modalbox',
      // data: {
      //   key: data.custombuttonclick.btninfo.previewlist,
      //   value: res.result || {},
      //   override: this.libdata.detailview_override,
      // },
      // });
      this.loader = true;
      this.apiservice
        .getHttpDataPost('refund-processing/refund-request-list-details', {
          _id: rowData._id,
        })
        .subscribe(
          (res: any) => {
            if (res.status === 'success') {
              const dialogRef = this.dialog.open(
                RefundRequestPreviewComponent,
                {
                  panelClass: 'custom-modalbox',
                  data: {
                    key: data.custombuttonclick.btninfo.previewlist,
                    value: res.results || {},
                    override: this.libdata.detailview_override,
                  },
                }
              );
              this.loader = false;
            } else {
              this.matSnackBar.open('Failed to load order preview.', 'Close', {
                duration: 3000,
                panelClass: ['snackbar-error'],
              });
              this.loader = false;
            }
          },
          (err) => {
            console.error('Order preview error:', err);
            this.matSnackBar.open(
              'Something went wrong while loading preview.',
              'Close',
              {
                duration: 3000,
                panelClass: ['snackbar-error'],
              }
            );
            this.loader = false;
          }
        );
    }
    // **New logic for the comment button**
    else if (data?.custombuttonclick?.btninfo?.id === 'comment_btn') {
      this.loader = true;
      this.apiservice
        .getHttpDataPost(
          '/refund-processing/fetch-refund-request-comment-list-details',
          {
            _id: rowData._id,
          }
        )
        .subscribe(
          (res: any) => {
            console.log('REs=====>', res);
            if (res.status === 'success') {
              this.updateTableAfterSubmit();
              const dialogRef = this.dialog.open(
                RefundCommentSectionComponent,
                {
                  panelClass: 'custom-modalbox',
                  width: '600px',
                  data: {
                    commentList: res.results || [],
                    requestInfo: rowData,
                  },
                }
              );
            } else {
              this.matSnackBar.open('Failed to load comments.', 'Close', {
                duration: 3000,
                panelClass: ['snackbar-error'],
              });
            }
            this.loader = false;
          },
          (err) => {
            console.error('Fetch comments error:', err);
            this.matSnackBar.open(
              'Something went wrong while loading comments.',
              'Close',
              {
                duration: 3000,
                panelClass: ['snackbar-error'],
              }
            );
            this.loader = false;
          }
        );
    } else if (data?.custombuttonclick?.btninfo?.id === 'activity_btn') {
      this.loader = true;

      const rowData = data?.custombuttonclick?.data;
      const payload = {
        condition: { limit: 100, skip: 0 },
        searchcondition: { refundRequestId: rowData._id },
        sort: { type: 'desc', field: 'createdAt' },
        project: {},
      };

      this.apiservice
        .getHttpDataPost('/refund-activity/refund-activity-log-list', payload)
        .subscribe({
          next: (res: any) => {
            this.loader = false;
            if (res.status === 'success') {
              this.dialog.open(RefundRequestActivityLogComponent, {
                panelClass: 'custom-modalbox',
                data: {
                  value: rowData,
                  activityItems: res.results || [],
                },
              });
            } else {
              this.matSnackBar.open('Failed to load activity logs.', 'Close', {
                duration: 3000,
              });
            }
          },
          error: (err) => {
            this.loader = false;
            console.error('Fetch activity log error:', err);
            this.matSnackBar.open(
              'Something went wrong while loading activity logs.',
              'Close',
              {
                duration: 3000,
              }
            );
          },
        });
    }
  }

  onLiblistingButtonChange(data: any = null) {
    console.log('onLiblistingButtonChange', data);
  }

  fetchRefundRequests(): void {
    // Logic to fetch refund requests
  }
}
